import Assets from "./assets.vue";
import InnoDescription from "./innovadis/inno-description.vue"; // Innovadis custom: Custom description
import InnoProperties from "./innovadis/inno-properties.vue"; // Innovadis custom: Custom properties
import InnoVariations from "./innovadis/inno-variations.vue"; // Innovadis custom: Custom variations
// import Options from "./options.vue";
import type { Component } from "vue";

const templateBlocks: { [key: string]: Component } = {
  "product-assets": Assets,
  "product-description": InnoDescription,
  "product-properties": InnoProperties,
  "product-variations": InnoVariations,
};

export default templateBlocks;
